import { Volume, OptLogVolumeActions } from '~/shared/types/api';

import type { AutoscaleRule } from '~/fleet-manager/components/FleetManagerPage/AutoscaleRulesPage/AutoscaleRulesTable/hooks/useAutoscaleRulesQuery';

export function generateSkeletonRows<T>(count: number, template: Partial<T>): T[] {
  return Array.from({ length: count }, (_, index) => ({
    ...template,
    id: `skeleton-${index}`,
    volumeId: `skeleton-volume-${index}`, // Unique volumeId for each skeleton row
    ruleId: `skeleton-rule-${index}`, // Unique ruleId for each skeleton rule
    _isSkeleton: true,
  })) as T[];
}

export function createSkeletonRule(): AutoscaleRule & { _isSkeleton: true } {
  return {
    ruleId: 'skeleton-rule',
    enabled: false,
    conditions: [],
    volumes: 0,
    capacity: 0,
    utilization: '0%',
    exceptions: 0,
    account: '',
    rawRule: {},
    _isSkeleton: true,
  } as AutoscaleRule & { _isSkeleton: true };
}

export function createSkeletonVolume(): Volume & { _isSkeleton: true } {
  const baseVolume: Volume = {
    volumeId: 'skeleton-volume', // Will be overridden by generateSkeletonRows
    volumeName: '',
    monitoring: 'Unmonitored',
    clusterName: '',
    instanceId: '',
    datafyDiskSize: 0,
    datafyDiskUsed: 0,
    diskSize: 0,
    diskUsed: 0,
    iops: 0,
    throughput: 0,
    awsState: '',
    awsStatus: '',
    availabilityZone: '',
    region: '',
    nodeGroupName: '',
    osImage: '',
    isBootDisk: false,
    yearlyEstimatedSavings: '',
    yearlyRealizedSavings: '',
    tags: [],
    attachedToInstances: {},
    utilization: 0,
  };

  return {
    ...baseVolume,
    _isSkeleton: true,
  } as Volume & { _isSkeleton: true };
}

export function createSkeletonAction(): OptLogVolumeActions & { _isSkeleton: true } {
  const baseAction: OptLogVolumeActions = {
    volumeId: 'skeleton-action', // Will be overridden by generateSkeletonRows
    instanceId: '',
    type: 'Growth',
    originalDiskSizeGb: 0,
    newDiskSizeGb: 0,
    actionFinishTime: '',
  };

  return {
    ...baseAction,
    _isSkeleton: true,
  } as OptLogVolumeActions & { _isSkeleton: true };
}
